import { ModalSidebar } from 'bold-ui'
import { VerticalStep, VerticalStepper } from 'components/vertical-stepper'

import { getConnectorStatus, getStatus } from './util-requisicaoExame'

interface RequisicaoExameModalSidebarProps {
  activeStepIdx: number
  completedStepsIdx?: number[]
  steps: string[]
}

export function RequisicaoExameModalSidebar(props: Readonly<RequisicaoExameModalSidebarProps>) {
  const { activeStepIdx, completedStepsIdx = [], steps } = props

  return (
    <ModalSidebar position='left'>
      <VerticalStepper gap={8}>
        {steps.map((stepTitle, index) => {
          const connectorStatus = getConnectorStatus(activeStepIdx, completedStepsIdx, index)
          const status = getStatus(activeStepIdx, completedStepsIdx, index)
          const hasConnector = index !== steps.length - 1

          return (
            <VerticalStep
              key={stepTitle}
              header={stepTitle}
              connectorStatus={connectorStatus}
              status={status}
              hasConnector={hasConnector}
            />
          )
        })}
      </VerticalStepper>
    </ModalSidebar>
  )
}
